/** @format */

import React, { useEffect } from 'react';
import {
	ModalContiner,
	ModalWrapper,
	HeaderContainer,
	TitleWrapper,
	CloseWrapper,
	BodyContainer,
	InnerContainer,
	UrlWrapper
} from './styles';
import Button from 'components/V2/Button';
import close_svg from '../../../../images/img/closed.svg';
import { Trans } from 'react-i18next';
import { copyText } from 'utils/utils';

const Share = ({ closeModal, copyContent }) => {
	useEffect(() => {
		copyText(copyContent);
	}, [copyContent]);

	return (
		<ModalContiner>
			<ModalWrapper>
				<HeaderContainer>
					<TitleWrapper>
						<Trans i18nKey="shareModal.modalTitle" />
					</TitleWrapper>
					<CloseWrapper onClick={closeModal}>
						<img src={close_svg} />
					</CloseWrapper>
				</HeaderContainer>
				<BodyContainer>
					<InnerContainer>
						<UrlWrapper>{copyContent}</UrlWrapper>
						<Button onClick={() => copyText(copyContent)} size="small">
							<Trans i18nKey="shareModal.button" />
						</Button>
					</InnerContainer>
				</BodyContainer>
			</ModalWrapper>
		</ModalContiner>
	);
};

export default React.memo(Share);
